<template>
	<div class="aside_right">
		<div class="teplate_tit">
			<div class="teplate_tits">
				<div @click="saveId"> + 制作内容</div>
			</div>
			<div class="conlist clearfix" v-if="formData.tamplate_id==3" v-for="(item,key) in inforShow" v-cloak>
				<div class="list_tit clearfix">
					<div class="tits fl_left">{{item.json_data.bg_title}}</div>
					<div class="music fl_left" v-if="item.json_data.music" v-for="(itemMusic,keyMusic) in item.json_data.music" @click="play($event,key,keyMusic)"> 
						<div class="music_icon">
							<audio :src="itemMusic.src" class="play"></audio>
						</div>
					</div>
					<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)" v-if="item.have_explain == 1">
						<span>教学详解</span>
					</div>
					<div class="xq_box" >
						<div class="xq_conTer">
							<div class="xq_del" @click="xq_hide($event)"></div>
							<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
								<div class="clearfix">
									<div class="xqTit fl_left">{{itemBkxq.title}}</div>
									<div class="music fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.music" @click="plays($event,key,ky,keysMusic)"> 
										<div class="music_icon">
											<audio :src="itemMusicq.src" class="play"></audio>
										</div>
									</div>
								</div>
								<div class="xqCon"  >
									<div v-if="itemBkxq.bg_text" v-html="itemBkxq.bg_text"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="list_wb">
					<div class="wb_con">
						<div class="wb_tit" v-html="item.json_data.bg_text">{{item.json_data.bg_text}}</div>
					</div>
				</div>

				<div class="editor_dele">
					<el-button icon="el-icon-edit" size="mini" @click="xgContent($event,1,key)" >编辑</el-button>
					<el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteSection(item.id,key)" >删除</el-button>
				</div>
			</div>
		</div>
		<div class="mark_wrap" v-if="lmcon">
			<div class="tishi_Infor">
				<div class="tishi_con">请先添加左侧栏目</div>
				<div class="tishi_btn" @click="sure">确定</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				isActive:0,
				music_state:0,
				feomLsit:this.formData,
				inforShow:[],
				toId:null,
				toId2:[],
				inforShow1:[],
				XQtoId:null,
				cxID:'',
				lmcon:false,
				xgCon:null
			}
		},
		props:['formData'],
		methods:{
			xgContent(e,val,i){
				e.stopPropagation();
				if(val == 2) return 
				const _this = this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);

				if(sessionStorage.getItem('changeNum') == null){
					// var tep_crey=JSON.stringify(this.formData);
					sessionStorage.setItem('formID',JSON.stringify({crey:_this.formData.module_id,conId:_this.inforShow[i].id}))
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}else{
					sessionStorage.setItem('formID',JSON.stringify({crey:parseInt(sessionStorage.getItem('changeNum')),conId:_this.inforShow[i].id}))
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}
			},
			//删除段
			deleteSection(section_id,key){
				let _this=this;
				_this.$confirm('确认删除此段落吗？此操作不可恢复，请确认', '删除提示', {
					onfirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$axios.post('deletedetail',{
						detail_id:section_id
					}).then((res)=>{
						if(res.data.code == 200)
						{
							_this.$message({type: 'success',message: '删除成功!'});
							this.inforShow.splice(key,1);
						}else{
							_this.$message.error(res.data.message)
						}
					}).catch((err)=>{
						console.log(err)
					})
				}).catch((error) => {     
				});	
			},
			// xgContent(e,i){
			// 	e.stopPropagation();
			// 	const _this=this;
			// 	var tep_crey=JSON.stringify(this.formData)
			// 	localStorage.setItem('template',tep_crey);

			// 	if(sessionStorage.getItem('changeName')==null){
			// 		var tep_crey=JSON.stringify(this.formData);
			// 		sessionStorage.setItem('formID',JSON.stringify({crey:_this.formData.creyId,conId:_this.inforShow[i].id}))
			// 		_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
			// 		window.localStorage.setItem('template',tep_crey);
			//  		_this.$router.push({
			// 			path:'/manager/addCategory/startFrom',
			// 			name:'wz',
			// 			query:{
			// 				courseid:this.formData.course_id,
			// 				package:this.$route.query.package,
			// 				id:this.$route.query.id,
			// 				table_id:this.$route.query.table_id,
			// 				pocId:this.$route.query.pocId
			// 			}
			// 		})
			// 	}else{
			// 		sessionStorage.setItem('formID',JSON.stringify({crey:parseInt(sessionStorage.getItem('changeName')),conId:_this.inforShow[i].id}))
			// 		this.formData.creyId=parseInt(sessionStorage.getItem('changeName'))
			// 		var tep_crey=JSON.stringify(this.formData);
			// 		_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
			// 		window.localStorage.setItem('template',tep_crey);
			//  		_this.$router.push({
			// 			path:'/manager/addCategory/startFrom',
			// 			name:'wz',
			// 			query:{
			// 				courseid:this.formData.course_id,
			// 				package:this.$route.query.package,
			// 				id:this.$route.query.id,
			// 				table_id:this.$route.query.table_id,
			// 				pocId:this.$route.query.pocId
			// 			}
			// 		})
			// 	}
			// },
			sure(){
				this.lmcon=! this.lmcon
			},
			xq_hide(e){
				e.stopPropagation();
				$('.xq_box').hide();
			},
			xq_show(e,i){
				e.stopPropagation();
				$('.xq_box').show()
				let _this = this ;
				_this.$axios.post('getexplainlist',{
					detail_id:_this.inforShow[i].id
				}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow1 = res.data.data.json_data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
				if(typeof($(document).find('video')[0])== 'object'){
					$(document).find('video')[0].pause()
				}
			},
			saveId(){
				const _this=this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);
				sessionStorage.removeItem('formID')
				if(sessionStorage.getItem('changeNum')==null){
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);

					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}else{
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}
			},
			play(e,i,j){
				e.stopPropagation();
				if($('.conlist').eq(i).find('.list_wb').find('.wb_con').children('.wb_tit').find('p').children('video').length>0){
					$('.conlist').eq(i).find('.list_wb').find('.wb_con').children('.wb_tit').find('p').children('video')[0].pause()
				}
				$('.music_icon').children('.play').get(0).pause()
				$('.music_icon').removeClass('zcir')
				if(this.music_state){
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).pause()
					this.music_state=0;
					$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').removeClass('zcir');
				}else{
					$('.conlist').eq(i).find('.music').eq(j).find('.play').get(0).play().then((res)=>{
						this.music_state=1
						$('.conlist').eq(i).find('.music').eq(j).find('.music_icon').addClass('zcir')
					})
				}				
			},
			plays(e,i,j,l){
				e.stopPropagation();
				$('.music_icon').children('.play').get(0).pause()
				$('.music_icon').removeClass('zcir')
				if(this.music_state){
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).pause()
					this.music_state=0;
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').removeClass('zcir');
				}else{
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').get(0).play().then((res)=>{
						this.music_state=1
						$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.music_icon').addClass('zcir')
					})
				}		
			},
			changeRightCon(){
				const _this=this;
				_this.$axios.post('getdetaillist',{
					column_id:_this.formData.module_id
				}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow = res.data.data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
			}
		},
		created(){
			var _this=this;
			console.log(this.formData)
			_this.changeRightCon()
		},
		watch:{
			formData:{
				 handler(){
				 	const _this=this;
					 $('.xq_box').hide()
					_this.changeRightCon()
				 },
				 deep:true	
			}
		}
	};
</script>
<style scoped>
	.aside_right{
		width: 830px;
		box-sizing: border-box;
		min-height: 581px;
		overflow:auto;
		background: rgba(230, 175, 169, 0.95);
		/*cursor:not-allowed*/
		padding:20px 0 0 32px;
		position: relative;
		font-size: 18px;
		overflow-y: auto;
	}
	.teplate_tits{
		width: 148px;
		height: 44px;
		box-sizing: border-box;
		line-height: 44px;
		text-align: center;
		/* color: #fff; */
		border-radius: 6px;
		/* border:1px dashed #fff; */
		background: #dfb055;
		border: #dfb055 1px solid;
		color: #333;
		font-size: 16px;
		cursor: pointer;
	}
	.teplate_tit{
		width:797px;
		overflow-y:auto;
		height: 480px;
	}
	.teplate_tit::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.teplate_tit::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.teplate_tit::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.aside_right::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.aside_right::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.aside_right::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.conlist{
		box-sizing: border-box;
	}
	.list_tit{
		/* color: #333; */
		color: #fff;
		/* padding-top: 12px; */
	}
	.list_wb{
		/* color: #333; */
		color: #fff;
		width: 725px;
	}
	.list_wb .wb_tit{
		/* margin-bottom: 12px; */
		font-size: 20px;
	}
	.list_wb .wb_tit img{
		display: inline-block;
	}
	.wb_main{
		margin-left: 10px;
		height: 30px;
		line-height: 30px;
	}
	.tits{
		font-size: 22px;
	}
	.tits,.music,.bkxq_wrapper{
		height: 45px;
		line-height: 45px;
	}
	.music{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 45px;
	}
	.music_icon{
		background: url(../../../../static/imgs/icon_music.png) 0 center no-repeat;
		background-size: 100%;
		width: 28px;
		height: 28px;
		float: left;
		margin-left: 14px;
		cursor: pointer;
	}
	.music_icon audio{
		display: none;
	}
	.bkxq_wrapper{
		width: 100px;
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		text-align: center;
		color: #f095b9;
		border-radius: 4px;
		border:1px solid #f095b9;
		background: #fff;
		margin-top: 8px;
		cursor: pointer;
		margin-right: 20px;
	}
	.xq_box{
		position: absolute;
		top: 0;
		left: 0;
		width: 830px;
		height: 500px;
		overflow:auto;
	/*	background: rgba(230, 175, 169, 0.95);*/
	 	background: url(../../../../static/imgs/startback.png) 0 0 no-repeat; 
		background-attachment: scroll;
		/* box-sizing: border-box; */
		background-size: cover;
		/*padding: 20px 25px 0;*/
		display: none;
		z-index: 99;
	}
	.xq_conTer{
		box-sizing: border-box;
		background: rgba(230, 175, 169, 0.95);
		padding: 20px 25px 0;
		height: 100%;
		overflow-y:auto;
	}
	.xq_conTer::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_conTer::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_conTer::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.xq_del{
		position: absolute;
		top: 20px;
		right: 20px;
		width: 24px;
		height: 24px;
		background: url(../../../../static/imgs/xdel.png) 0 0 no-repeat;
		cursor: pointer;
	}
	.xq_list{
		margin-bottom: 20px;
	}
	.xqTit{
		font-size: 20px;
		line-height: 45px;
		margin-bottom: 10px;
		color: #fff;
	}
	.xqCon{
		line-height: 32px;
		margin-bottom: 10px;
		/* background: url(../../static/imgs/tn_cir.png) 0 13px no-repeat; */
		background-size: 8px;
		color: #fff;
	}
	.imgsrc{
		margin-bottom: 10px;
	}
	.imgsrc img{
		max-width: 200px;
		max-height: 143px;
		display: inline-block;
		margin: 0 5px;
		border:none;
	}
	.zcir{
		animation: go 1.5s infinite; 
		animation-fill-mode:both;
	}
	@keyframes go{
		0%{
			transform: rotateZ(0);
		}
		100%{
			transform: rotateZ(360deg);
		}
	}
	.videoSrc{
	width: 255px;
	height: 160px;
	}
	.videoSrc video{
		width: 100%;
		height: 100%;
	}
	.xqImg{
		width: 255px;
		height: 160px;
	}
	.xqImg img{
		width:100%;
		height: 100%;
	}
	.mark_wrap{
		width: 100%;
		height: 100%;	
		background: rgb(245,245,245,0.55);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tishi_Infor{
		width:400px;
		height: 150px;
		font-size: 16px;
		background: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		font-family: "微软雅黑"
	}
	.tishi_btn{
		margin-top: 30px;
		cursor: pointer;
		width: 116px;
		height: 32px;
		background: #595DB5;
		text-align: center;
		line-height: 32px;
		border-radius: 4px;
		color: #fff;
	}
	.video-widy{
		width: 230px;
		height: 136px;
	}
	.video-widy video{
		max-width: 230px;
		max-height: 136px;
	}
	.conlist {border: 1px dashed #efefef;}
	.conlist:hover {border: 1px dashed #CCcccc;}
</style>


// WEBPACK FOOTER //
// src/components/index/template/tepBw.vue